export enum OrderSource {
    Desktop = 1,
    Mobile = 2,
}
